import React, { useState, useEffect } from 'react';
import { Drawer, Button, Select, message, Input, Form, Spin, Card, Tag,Divider,Checkbox } from 'antd';
import { ConsoleSqlOutlined, DeleteOutlined,PlusOutlined } from '@ant-design/icons';
import FiltersDynamic from '../Components/FiltersDynamicComponent';
import ApiService from '../Components/apiService';
import { BASE_URL } from '../Components/Constant';

const { Option } = Select;

const UpdateNodeFlowDrawer = ({isEditingMode,selectedNode, visible, onClose, nodeData, onSave,setNodeData }) => {
  const [objects, setObjects] = useState([]);
  const [fields, setFields] = useState([]);
  const [selectedObject, setSelectedObject] = useState(null);
  const [filters, setFilters] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');
  const [apiName, setApiName] = useState('');
  const [description, setDescription] = useState('');
  const [fieldValues, setFieldValues] = useState({}); // New state to track values of selected fields
  const [logic, setLogic] = useState('');
  const [operator, setOperator] = useState('AND');
  const [valueOperator, setValueOperator] = useState('');
  const [fieldValuePairs, setFieldValuePairs] = useState([{ field: '', value: '' }]);
  const [selectedFieldNames, setSelectedFieldNames] = useState([]);
  const [selectedManualUpdating,setSelectedManualUpdating] = useState(false);
  const [selectedRecord,setSelectedRecord] = useState("");
  const [selectedObjectForRecordVariable,setSelectedObjectForRecordVariable] = useState(null);
  useEffect(() => {
    if (visible) {
      fetchObjects();
    }
  }, [visible]);

  useEffect(() => {
    if (nodeData && Object.keys(nodeData).length > 0) {
        console.log('nodedataLL:::',nodeData);
       if(nodeData?.parameters?.updated_record){
        setSelectedManualUpdating(false);
        setName(nodeData?.label ? nodeData?.label : nodeData?.name || '');
        setApiName(nodeData?.apiName ? nodeData?.apiName : nodeData?.name|| '');
        setDescription(nodeData?.description || '');
        setSelectedObjectForRecordVariable(nodeData?.parameters?.model);
        setSelectedRecord(nodeData?.parameters?.updated_record);

       }else{
            setName(nodeData?.label ? nodeData?.label : nodeData?.name || '');
            setApiName(nodeData?.apiName ? nodeData?.apiName : nodeData?.name|| '');
            setDescription(nodeData?.description || '');
            setSelectedObject(nodeData?.parameters?.model || null);
            setLogic(nodeData?.parameters?.logic_string || '');
            setSelectedManualUpdating(true);
            const existingFilters = nodeData?.parameters?.conditions
                ? Object.entries(nodeData.parameters.conditions).map(([_, { field, value }]) => {
                    let operator = '';
                    let actualValue = '';

                    if (typeof value === 'object' && value !== null) {
                        operator = Object.keys(value)[0];
                        actualValue = value[operator];
                    } else {
                        actualValue = value;
                    }

                    return {
                        field,
                        value,
                        displayValue: actualValue,
                        operator
                    };
                    })
                : [{ field: '', value: '', operator: '', displayValue: '' }];

                setFilters(existingFilters);

        
            console.log('setFilters:::',filters);
            // Set field-value pairs
            setFieldValuePairs(
                nodeData?.parameters?.updates
                ? Object.entries(nodeData.parameters.updates).map(([field, value]) => ({ field, value }))
                : [{ field: '', value: '' }]
            );
        
            setSelectedFieldNames(
                nodeData?.parameters?.updates ? Object.keys(nodeData.parameters.updates) : []
            );
        
            setOperator('AND');
        
            // Fetch fields
            if (nodeData.parameters?.model) {
                fetchFields(nodeData.parameters.model);
            }
       }
        
    } else {
      // Reset everything
      setName('');
      setApiName('');
      setDescription('');
      setSelectedObject(null);
      setSelectedObjectForRecordVariable(null);
      setFieldValuePairs([{ field: '', value: '' }]);
      setSelectedFieldNames([]);
      setLogic('');
      setFilters([]);
      setOperator('AND');
      setSelectedManualUpdating(false);
      setSelectedRecord("");
      

    }
  }, [visible]);
  
  

  const fetchObjects = async () => {
    try {
      setLoading(true);
      const apiService = new ApiService(`${BASE_URL}/mt_objects`, { 'Content-Type': 'application/json' }, 'GET');
      const response = await apiService.makeCall();
      setObjects(response);
    } catch (error) {
      console.error('Error fetching objects:', error);
      message.error('Failed to fetch objects.');
    } finally {
      setLoading(false);
    }
  };

  const fetchFields = async (objName) => {
    try {
      setLoading(true);
      const apiService = new ApiService(`${BASE_URL}/mt_fields/object/${objName}`, { 'Content-Type': 'application/json' }, 'GET');
      const response = await apiService.makeCall();
      setFields(response);
    } catch (error) {
      console.error('Error fetching fields:', error);
      message.error('Failed to fetch fields.');
    } finally {
      setLoading(false);
    }
  };

  const handleObjectChange = (value) => {
    setSelectedObject(value);
    fetchFields(value);
  
    // Clear previously selected field-value pairs
    setFieldValuePairs([{ field: '', value: '' }]); // Initialize with one empty pair
    setSelectedFieldNames([]);
  };

  const handleObjectChangeForRecordVariable = (value) =>{
    setSelectedObjectForRecordVariable(value);

  }
  
  const handleFieldSelect = (field) => {
    if (!selectedFieldNames.includes(field)) {
      setFieldValuePairs([...fieldValuePairs, { field, value: '' }]);
      setSelectedFieldNames([...selectedFieldNames, field]);
    }
  };
  

  const handleFieldValueChange = (field, value) => {
    setFieldValues({ ...fieldValues, [field]: value }); // Update the value for the selected field
  };

  const handleRemoveField = (field) => {
    setSelectedFields(selectedFields.filter((f) => f !== field));
    const { [field]: removed, ...rest } = fieldValues; // Remove the value associated with the field
    setFieldValues(rest);
  };

  const handleSave = () => {
    if(selectedManualUpdating){
        if (!name || !apiName || !(selectedObject || selectedObjectForRecordVariable)  || fieldValuePairs.length === 0 || fieldValuePairs.some(p => !p.field)) {
            message.error('Please fill all required fields.');
            return;
          }
    }
    else{
        console.log('naem',name);
        console.log('api',apiName);
        console.log('api',selectedRecord);
        if (!name || !apiName || !selectedRecord) {
            message.error('Please fill .');
            return;
          }
    }
    
  
    const type = "update";
    const is_var_update = !selectedManualUpdating;
    if(selectedManualUpdating){ 
        // Convert filters to condition format
        const conditions = filters.reduce((acc, filter, index) => {
            if (filter.field) {
            acc[index + 1] = {
                field: filter.field,
                value: filter.value
            }; 
            }
            return acc;
        }, {});
    
        // const conditions = filters.map((filter) => {
        //   const { field, operator, displayValue } = filter;
        //   if (!field || displayValue === undefined || displayValue === '') return null;
    
        //   // Build the value object based on operator
        //   const valueObj = operator ? { [operator]: displayValue } : displayValue;
    
        //   return {
        //     field,
        //     value: valueObj,
        //   };
        // }).filter(Boolean); // Remove nulls
        
        console.log('conditionn:::',conditions);
        // Convert field-value pairs to object
        const updates = fieldValuePairs.reduce((acc, { field, value }) => {
        if (field) acc[field] = value || '';
        return acc;
        }, {});
      
        const parameters = {
            model: selectedObject || '',
            logic_string: logic || '1',
            conditions,
            updates,
            is_var_update
        };
    
        const data = {
            name,
            apiName,
            description,
            type,
            parameters,
        };
    
        console.log('data::', data);
    
        onSave(selectedNode.id, data); // Pass to parent
    }else{
        const data = {
            name,
            apiName,
            description,
            type,
            parameters:{
                updated_record:selectedRecord,
                model:selectedObjectForRecordVariable,
                is_var_update
            }

                        
        };
        
        console.log('data::', data);
    
        onSave(selectedNode.id, data); // Pass to parent
    }
    
    // message.success('Update Record saved successfully!');
    // setNodeData([]);
    // onClose();
  };
  
  const handleCheckBox = (event) => {
    console.log('chceck',event);
    const isChecked = event.target.checked;
    setSelectedManualUpdating(event.target.checked);
    if(isChecked){
        setSelectedRecord(""); // Clear record input if any
        setSelectedObjectForRecordVariable(null);
    }
    else{
        setFieldValuePairs([]); // Clear field-value pairs
        setSelectedFieldNames([]);
        setFilters([]); // Clear filters
        setLogic("");   // Clear logic
        setSelectedObject(null);    
    }
        
    
  }
  
const handleCancel = ()=>{
  setNodeData([]);
  onClose();
}
  const filteredFields = fields.filter((field) => !selectedFields.includes(field.name));

  return (
    <Drawer
      title={`Update Records`}
      placement="right"
      onClose={handleCancel}
      mask={false}
      zIndex={1002}   // higher than sidebar
      visible={visible}
      width={600}
      footer={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button type="default" onClick={handleCancel}>
            Cancel
          </Button>
          <Button type="primary" onClick={handleSave}>
            Save
          </Button>
        </div>
      }
      footerStyle={{ textAlign: 'right' }}
    >
      {loading ? (
        <Spin tip="Loading..." />
      ) : (
        <Form layout="vertical">
          <Form.Item label="Name" required>
            <Input
              placeholder="Enter name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onBlur={() => {
                if (name) {
                  setApiName(
                    name
                      .replace(/[^a-zA-Z0-9]/g, "") // Remove special characters
                      .replace(/\s+/g, "") // Remove spaces
                      .trim()
                  );
                }
              }}          
            />
          </Form.Item>

          <Form.Item label="API Name" required>
            <Input
              placeholder="Enter API name"
              value={apiName}
              onChange={(e) => setApiName(e.target.value)}
              disabled
            />
          </Form.Item>

          <Form.Item label="Description">
            <Input.TextArea
              placeholder="Enter description"
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Form.Item>
          <Form.Item>
            <Checkbox
                checked={selectedManualUpdating}
                // onChange={(e) => setSelectedManualUpdating(e.target.checked)}
                onChange={handleCheckBox}
            >
                Specify conditions to identify records, and set fields individually
            </Checkbox>
          </Form.Item>
          {selectedManualUpdating ? (
  <>
  <Form.Item label="Select Object" required>
            <Select
              placeholder="Select Object"
              style={{ width: '100%' }}
              onChange={handleObjectChange}
              value={selectedObject}
            >
              {objects.map((obj) => (
                <Option key={obj.name} value={obj.name}>
                  {obj.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
    {selectedObject && (
      <FiltersDynamic
        fields={fields}
        filters={filters}
        setFilters={setFilters}
        logic={logic}
        setLogic={setLogic}
        setValueOperator={setValueOperator}
        valueOperator={valueOperator}
      />
    )}

    <Divider style={{ paddingTop: 20, borderBlockStart: '2px solid #d9d9d9' }} orientation="left">
      Set Field Values for the {selectedObject || "Selected Object"}
    </Divider>

    {fieldValuePairs?.map((pair, index) => (
      <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
        <Select
          style={{ width: '40%' }}
          placeholder="Select a field"
          value={pair.field}
          onChange={(value) => {
            const newPairs = [...fieldValuePairs];
            const prevField = newPairs[index].field;

            newPairs[index].field = value;
            setFieldValuePairs(newPairs);

            setSelectedFieldNames((prev) => {
              const updated = [...prev];
              if (prevField) {
                const idx = updated.indexOf(prevField);
                if (idx !== -1) updated.splice(idx, 1);
              }
              if (value) updated.push(value);
              return updated;
            });
          }}
        >
          {filteredFields
            .filter(field => !selectedFieldNames.includes(field.name) || pair.field === field.name)
            .map(field => (
              <Option key={field.name} value={field.name}>{field.label}</Option>
            ))}
        </Select>

        <span style={{ margin: '0 10px' }}>←</span>

        <Input
          style={{ width: '40%' }}
          placeholder="Enter value"
          value={pair.value}
          onChange={(e) => {
            const newPairs = [...fieldValuePairs];
            newPairs[index].value = e.target.value;
            setFieldValuePairs(newPairs);
          }}
        />

        <Button
          icon={<DeleteOutlined />}
          danger
          onClick={() => {
            const removedField = fieldValuePairs[index].field;
            const newPairs = fieldValuePairs.filter((_, i) => i !== index);
            setFieldValuePairs(newPairs);
            setSelectedFieldNames((prev) => prev.filter((f) => f !== removedField));
          }}
          style={{ marginLeft: 10 }}
        />
      </div>
    ))}

    <Button
      type="dashed"
      icon={<PlusOutlined />}
      onClick={() => setFieldValuePairs([...fieldValuePairs, { field: '', value: '' }])}
    >
      Add Field
    </Button>
  </>
) : (
  <>
    {/* <Form.Item label="Select Record(s) to Update" required> */}
    <Form.Item label="Select Object" required>
            <Select
              placeholder="Select Object"
              style={{ width: '100%' }}
              onChange={handleObjectChangeForRecordVariable}
              value={selectedObjectForRecordVariable}
            >
              {objects.map((obj) => (
                <Option key={obj.name} value={obj.name}>
                  {obj.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
    <Form.Item label="Enter Record to Update" required>
      <Input
        placeholder="E.g., Account from Get Records 1"
        value={selectedRecord}
        onChange={(e) => setSelectedRecord(e.target.value)}
      />
    </Form.Item>

      {/* Replace this block with your actual record selection UI logic or component */}
      {/* <Select
        style={{ width: '100%' }}
        placeholder="Select a record"
        value={selectedRecord}
        onChange={(value) => setSelectedRecord(value)}
        showSearch
      >
        {recordOptions.map((rec) => (
          <Option key={rec.id} value={rec.id}>
            {rec.label}
          </Option>
        ))}
      </Select> */}
    {/* </Form.Item> */}
  </>
)}


        </Form>
      )}
    </Drawer>
  );
};

export default UpdateNodeFlowDrawer;
